import { Box } from 'components/elements'
import { CSS } from 'theme'
import { ShimmerCss } from '.'

interface ButtonShimmerProps {
  css?: CSS
}

export const ButtonShimmer = ({ css }: ButtonShimmerProps) => {
  return (
    <Box
      css={{
        ...ShimmerCss,
        ...ButtonItemCss,
        mr: '$space$10',
        borderRadius: '$sm',
        ...css,
      }}
    ></Box>
  )
}

const ButtonItemCss = {
  width: 120,
  height: 40,
}
